import React, { useEffect, useState } from "react";
import { Col, Row, Button, Form, message, Divider, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import {
  AiOutlineCheckCircle,
  AiOutlineInfoCircle,
  AiOutlineCloseCircle,
} from "react-icons/ai";
// component
import PaymentEmail from "./component/payment_email";
import PaymentFirstName from "./component/payment_first_name";
import PaymentLastName from "./component/payment_last_name";
import PaymentDOB from "./component/payment_dob";
import PaymentGender from "./component/payment_gender";
import PaymentAddress from "./component/payment_address";
import PaymentAddressCity from "./component/payment_address_city";
import PaymentAddressState from "./component/payment_address_state";
import PaymentAddressSuburb from "./component/payment_address_suburb";
import PaymentAddressPostCode from "./component/payment_address_post_code";
import PaymentDescription from "./component/payment_description";
import PaymentDocumentFront from "./component/payment_document_front";
import PaymentDocumentBack from "./component/payment_document_back";
import PaymentAdditionalDocumentFront from "./component/payment_additional_document_front";
import PaymentAdditionalDocumentBack from "./component/payment_additional_document_back";
import PaymentPhone from "./component/payment_phone";
// redux
import { updateAccount, getAccount } from "../../store/stripe/stripe.action";
import { accountSelector } from "../../store/stripe/stripe.selector";
import { detailSelector } from "../../store/branch/branch.selector";

const BranchPaymentEdit = () => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const params = useParams();
  const branch = params?.id;
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const disabled = !edit || loading;
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const detail = useSelector(detailSelector);
  const stripeAccount = detail?.stripeAccount;
  const account = useSelector(accountSelector);
  console.log({ account });
  // -------------------------- FUNCTION --------------------------
  const onFinish = (values) => {
    // setLoading(true);
    const day = parseInt(moment(values.dob).format("DD"));
    const month = parseInt(moment(values.dob).format("MM"));
    const year = parseInt(moment(values.dob).format("YYYY"));
    const { docBack, docFront, addDocFront, addDocBack, ...data } = values;

    const verification = danDanLongLong({
      docFront,
      docBack,
      addDocFront,
      addDocBack,
    });

    const accountData = {
      ...data,
      verification,
      dob: { day, month, year },
      branch,
    };

    console.log({ accountData });

    dispatch(
      updateAccount({ stripeAccount, accountData }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          message.success("Update successfully!");
          dispatch(getAccount({ id: stripeAccount }));
          setEdit(false);
        } else {
          const error = response?.data?.raw?.message;
          console.log({ error, response });
          message.error(error);
        }
      })
    );
  };

  const onFinishFailed = (values) => {
    console.log({ failed: values });
  };

  const onSelectAddress = (values) => {
    form.setFieldsValue(values);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(getAccount({ id: stripeAccount }));
  }, [dispatch, form, stripeAccount]);

  useEffect(() => {
    if (account) {
      const email = account.email;
      const individual = account?.individual;
      const firstName = individual?.first_name;
      const lastName = individual?.last_name;
      const day = individual?.dob?.day;
      const month = individual?.dob?.month;
      const year = individual?.dob?.year;
      const fullDay = `${day}/${month}/${year}`;
      const dob = moment(fullDay, "DD/MM/YYYY");
      const gender = individual?.gender;
      const address = individual?.address?.line1;
      const postCode = individual?.address?.postal_code;
      const city = individual?.address?.city;
      const phone = individual?.phone;
      const description = account?.business_profile?.product_description;
      const verification = individual?.verification;
      const docBack = verification?.document?.back;
      const docFront = verification?.document?.front;
      const addDocBack = verification?.additional_document?.back;
      const addDocFront = verification?.additional_document?.front;
      const state = individual?.address?.state;
      const subUrb = individual?.address?.subUrb || "";
      // console.log("individual", individual);

      form.setFieldsValue({
        email,
        firstName,
        lastName,
        dob,
        gender,
        address,
        postCode,
        city,
        state,
        subUrb,
        description,
        phone,
        docBack,
        docFront,
        addDocBack,
        addDocFront,
      });
    }
  }, [account, form]);

  // -------------------------- DATA FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  const renderAccount = () => {
    return (
      <div style={{ marginBottom: 20 }}>
        Your Stripe Account: {detail?.stripeAccount} {renderStatus()}
      </div>
    );
  };

  const renderStatus = () => {
    const status = account?.individual?.verification?.status;
    if (status === "pending") {
      return (
        <Tooltip title="Pending">
          <AiOutlineInfoCircle color="orange" />
        </Tooltip>
      );
    } else if (status === "unverified") {
      return (
        <Tooltip title="Deny">
          <AiOutlineCloseCircle color="red" />
        </Tooltip>
      );
    } else if (status === "verified") {
      return (
        <Tooltip title="Verified">
          <AiOutlineCheckCircle color="green" />
        </Tooltip>
      );
    }
  };

  const renderForm = () => {
    return (
      <Form
        name="payment_form"
        autoComplete="off"
        form={form}
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <PaymentEmail disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentFirstName disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentLastName disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentDOB disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentGender disabled={disabled} />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <PaymentAddress disabled={disabled} onSelect={onSelectAddress} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentAddressCity disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentAddressState disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentAddressSuburb disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentAddressPostCode disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentDescription disabled={disabled} />
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <PaymentPhone disabled={disabled} />
          </Col>
          {/* <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <p>Identify Document (Passport)</p>
            <Row gutter={[16, 0]}>
              <Col>
                <PaymentDocumentFront disabled={disabled} />
              </Col>
              <Col>
                <PaymentDocumentBack disabled={disabled} />
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <p>Address Document (Utility Bill)</p>
            <Row gutter={[16, 0]}>
              <Col>
                <PaymentAdditionalDocumentFront disabled={disabled} />
              </Col>
              <Col>
                <PaymentAdditionalDocumentBack disabled={disabled} />
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} align="right">
            <Divider></Divider>
            {renderButtons()}
          </Col> */}
        </Row>
      </Form>
    );
  };

  const renderButtons = () => {
    if (!edit) {
      return (
        <Button
          type="primary"
          style={{}}
          loading={loading}
          onClick={() => setEdit(true)}
        >
          Edit
        </Button>
      );
    } else {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button
            type="default"
            style={{ marginRight: 10 }}
            loading={loading}
            onClick={() => setEdit(false)}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button form-button"
            style={{ backgroundColor: "green" }}
            loading={loading}
          >
            Save
          </Button>
        </div>
      );
    }
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 12]} style={{ borderRight: "0.5px solid #ccc" }}>
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderAccount()}
        {renderForm()}
      </Col>
    </Row>
  );
};

export default BranchPaymentEdit;

const danDanLongLong = ({ docFront, docBack, addDocFront, addDocBack }) => {
  const hasDocument = docFront || docBack;
  const document = {
    ...(docFront && { front: docFront }),
    ...(docBack && { back: docBack }),
  };
  const hasAddDocument = addDocFront || addDocBack;
  const additional_document = {
    ...(addDocFront && { front: addDocFront }),
    ...(addDocBack && { back: addDocBack }),
  };
  const hasVerrification = hasDocument || hasAddDocument;
  const verification = {
    ...(hasDocument && { document }),
    ...(hasAddDocument && { additional_document }),
  };
  return hasVerrification && verification;
};
